'use client';

export * from 'tailframes-components/components/breadcrumbs/breadcrumbs';
export * from 'tailframes-components/components/breadcrumbs/breadcrumbs-item';
